import { useContext, useEffect } from 'react';
import cx from 'classnames';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';

import { MicrophoneOffNewIcon, MicrophoneOnNewIcon } from 'components/Icon';

import { backstageContext } from './Backstage.Provider';

import styles from './Backstage.module.scss';

export type MicrophoneProps = {};

const AnimatedBackground = ({ maxHeight }: { maxHeight: number }) => {
  const {
    audio: { track, muted }
  } = useContext(backstageContext);
  const volumeLevel = useMotionValue(0);
  const height = useTransform(volumeLevel, [0, 1], [muted ? 0 : 1, maxHeight]);

  useEffect(() => {
    let volumeLevelTimeoutId: NodeJS.Timeout | undefined;

    if (!muted && track) {
      volumeLevelTimeoutId = setInterval(() => {
        const targetVolume = track.getVolumeLevel();

        animate(volumeLevel, targetVolume, { type: 'spring', stiffness: 400 });
      }, 50);
    } else {
      animate(volumeLevel, 0, { type: 'spring', duration: 0.7 });
    }

    return () => {
      if (volumeLevelTimeoutId) {
        clearInterval(volumeLevelTimeoutId);
      }
    };
  }, [track, muted, volumeLevel]);

  return <motion.div className={styles.bg} style={{ height }} />;
};

const Microphone = (props: MicrophoneProps): JSX.Element => {
  const {
    audio: { muted, loading },
    toggleAudio: toggle
  } = useContext(backstageContext);

  return (
    <div className={styles.container}>
      <button type="button" className={cx(styles.mic, { [styles.on]: !muted })} disabled={loading} onClick={toggle}>
        <AnimatedBackground maxHeight={108} />
        <p className={styles.title}>{muted ? 'Tap to test' : 'Speak'}</p>
        {muted ? <MicrophoneOffNewIcon /> : <MicrophoneOnNewIcon />}
      </button>
    </div>
  );
};

export default Microphone;
